import { render, staticRenderFns } from "./AddBIObjectButton.vue?vue&type=template&id=1c2fb382&scoped=true&"
import script from "./AddBIObjectButton.vue?vue&type=script&lang=ts&"
export * from "./AddBIObjectButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddBIObjectButton.vue?vue&type=style&index=0&id=1c2fb382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fb382",
  null
  
)

export default component.exports